import React, { useEffect, lazy } from 'react'
import { Switch, Route } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import TagManager from 'react-gtm-module'
import { hotjar } from 'react-hotjar'

import Layout from '~/pages/_layouts/default'

import { setConfigs } from '~/store/modules/config/actions'

const Checkin = lazy(() => import('~/pages/checkin'))
const Dashboard = lazy(() => import('~/pages/dashboard'))
const ErrorCampaign = lazy(() => import('~/pages/error-campaign'))
const Login = lazy(() => import('~/pages/login'))
const Logoff = lazy(() => import('~/pages/logoff'))
const Hub = lazy(() => import('~/pages/hub'))
const NotEligible = lazy(() => import('~/pages/not-eligible'))
const AdjustStock = lazy(() => import('~/pages/dashboard/status/adjust'))
const TransferStock = lazy(() => import('~/pages/dashboard/status/transfer'))
const StockHistory = lazy(() => import('~/pages/dashboard/status/history'))

export default () => {
  const dispatch = useDispatch()

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const params = new URLSearchParams(document?.location?.search)

  const {
    NODE_ENV,
    REACT_APP_GTM,
    REACT_APP_HOTJAR
  } = window?.env || {}

  useEffect(() => {
    if (NODE_ENV === 'production' && REACT_APP_GTM !== '#') {
      const tagManagerArgs = {
        gtmId: REACT_APP_GTM
      }

      TagManager.initialize(tagManagerArgs)
    }

    if (NODE_ENV === 'production' && REACT_APP_HOTJAR !== '#') {
      const [hjid, hjsv] = REACT_APP_HOTJAR.split('::')

      hotjar.initialize(hjid, hjsv)
    }
  }, [NODE_ENV, REACT_APP_GTM, REACT_APP_HOTJAR])

  useEffect(() => {
    if (params.get('webview')) {
      dispatch(setConfigs({ configs: { webview: true } }))
    }
  }, [params, dispatch])

  return (
    <Layout>
      <Switch>
        <Route path='/:campaignId/checkin' component={Checkin} />
        <Route path='/:campaignId/not-eligible' exact component={NotEligible} />
        <Route path='/:campaignId/dashboard' component={Dashboard} />
        <Route path='/:campaignId/supply/adjust' exact component={AdjustStock} />
        <Route path='/:campaignId/supply/transfer' exact component={TransferStock} />
        <Route path='/:campaignId/supply/history' exact component={StockHistory} />
        <Route path='/hub' exact component={Hub} />
        <Route path='/logoff' exact component={Logoff} />
        <Route path='/' exact component={Login} />
        <Route component={ErrorCampaign} />
      </Switch>
    </Layout>
  )
}
